import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["smartPropertyCount", "recordCount"];
import { LayoutBox, Body } from 'breeze-intelligence-kit';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import { PanelUsage } from '../Panel/PanelUsage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SmartFillPanelUsage = ({
  numberOfOperations
}) => /*#__PURE__*/_jsx(PanelUsage, {
  action: "SMART_PROPERTY_RUN",
  numberOfOperations: numberOfOperations
});
export const SmartFillPanelSummary = _ref => {
  let {
      smartPropertyCount,
      recordCount
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const smartPropertyText = I18n.text('smartProperties.panel.fillSummary.smartPropertyCount', {
    count: smartPropertyCount,
    smartPropertyCount
  });
  const recordCountText = I18n.text('smartProperties.panel.fillSummary.recordsFilledCount', {
    count: recordCount,
    recordFillCount: recordCount
  });
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({
    as: "div"
  }, rest, {
    children: /*#__PURE__*/_jsx(Body, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "smartProperties.panel.fillSummary.summary",
        options: {
          count: smartPropertyCount,
          smartPropertyCount: smartPropertyText,
          recordsFillCount: recordCountText
        }
      })
    })
  }));
};
export function SmartFillUsageSection({
  estimatedTotal,
  recordsToFill,
  selectedPropertiesCount,
  showSummary = true
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SmartFillPanelUsage, {
      numberOfOperations: estimatedTotal
    }), showSummary && /*#__PURE__*/_jsx(SmartFillPanelSummary, {
      recordCount: recordsToFill,
      smartPropertyCount: selectedPropertiesCount
    })]
  });
}